<script>
  import Button from "@ui/pico/button.svelte";
  import Terms from "../terms/index.svelte";
  import { ux } from "../../store";
  import { goto } from "../../util";
  import { pages } from "../../config";

  function triggerClose() {
    $ux.firstTime = false;
    goto(pages.dashboard.url);
  }
  function memberEntrance() {
    $ux.firstTime = false;
    goto(pages.entry.url);
  }
</script>

<dialog open>
  <div class="article">
    <header>
      <a
        on:click|preventDefault={triggerClose}
        href="#close"
        aria-label="Close"
        class="close"
      >
        &nbsp;
      </a>
      <hgroup>
        <h2>Welcome to Webforma</h2>
        <h4>
          Rapidly manage your web site forms in seconds and maybe for free.
          Registering is not required but appreciated.
        </h4>
      </hgroup>
    </header>
    <form on:submit|preventDefault={triggerClose}>
      <Terms />
      <Button type="submit" class="contrast" iconRight="log-in" iconSize={32}>
        Enter as Guest
      </Button>
      <Button
        on:click={memberEntrance}
        type="button"
        iconRight="log-in"
        iconSize={32}
      >
        I have an Account
      </Button>
    </form>
  </div>
</dialog>

<style>
  .article {
    min-width: 320px;
    max-width: 675px;
    width: 40%;
  }
</style>
